import { type Action, can } from '@quickreport/domain';
import { WorkflowError, type WorkspaceCtx } from './reports';

/** Stop with a plain message unless the person's roles allow this action. */
export function requirePermission(ctx: WorkspaceCtx, action: Action, message: string): void {
  if (!can(ctx.roles, action)) throw new WorkflowError(message);
}
